// @ts-nocheck
const feedbackEndpoint = "/api/v1/contactteam/reportpimdata";
import { post } from "@insite/client-framework/Services/ApiService";

interface FeedbackServiceParams {
    reportedBy: string;
    comment: string;
    sku: string;
    reportedURL: string;
}
const feedbackService = (feedbackServiceParams: FeedbackServiceParams) => {
    return post(feedbackEndpoint, feedbackServiceParams);
};

export default feedbackService;
